// @ts-strict-ignore
import React from 'react';

import {Visibility} from 'common/components/base/stackable';
import {ModalReact} from 'common/components/modal';
import {SvgIconReact} from 'common/components/svg-icon';
import {ButtonReact} from 'common/components/button';
import {ButtonSize, ButtonTheme} from 'common/components/button/constants';
import {withStyles} from 'common/util/react';
import {react2panel} from 'common/util/react2panel';
import {useTranslation} from 'common/i18n/hooks';
import {ProductUpdate} from 'app_api/product_updates/types';

import css from './index.module.styl?inline';
import styles from './index.module.styl';

type ChangelogModalProps = {
  productUpdates: ProductUpdate[];
  onCloseHandler: () => void;
};

function ChangelogModal(props: ChangelogModalProps) {
  const {t} = useTranslation();

  const formatProductUpdate = (update: ProductUpdate) => {
    return (
      <div className={styles.updateContainer}>
        <div className={styles.dateWrapper}> July 17, 2024 </div>
        <div className={styles.updateContent}>
          <div className={styles.updateLabel}> {update.label} </div>
          <div className={styles.updateDescription}>
            You choose date ranges that are specified up to the minute. If there's a metric that you want to drill in on
            for only a few hours, you can set your time range and see only that exact range.
            <a className={styles.readMoreLink} href={update.link}>
              {t(`help.changelog-modal.read-more`)}
            </a>
          </div>
          <div className={styles.loomContainer}>
            <SvgIconReact icon={`play-video`} />
            <a className={styles.loom}> {t(`help.changelog-modal.watch-loom`)} </a>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <ModalReact
        className={styles.modal}
        closeable
        open
        onChange={(event: CustomEvent) => {
          if (event.detail.state === Visibility.Closed) {
            props.onCloseHandler();
          }
        }}
      >
        <div className={styles.modalContent}>
          <div className={styles.title}> {t(`help.changelog-modal.whats-new`)}</div>
          {props.productUpdates &&
            props.productUpdates.slice(0, 3).map((productUpdate: ProductUpdate) => {
              return formatProductUpdate(productUpdate);
            })}
          <div className={styles.buttonContainer}>
            <ButtonReact className={styles.changelogButton} theme={ButtonTheme.Primary} size={ButtonSize.Large}>
              {t(`help.changelog-modal.see-full-changelog`)}
            </ButtonReact>
          </div>
        </div>
      </ModalReact>
    </div>
  );
}

export const ChangeModalReact = withStyles(ChangelogModal, css);
export const ChangelogModalEl = react2panel(`mp-changelog-modal`, ChangeModalReact);
